import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { FormControl } from 'uiKit/atoms/FormControl/FormControl';
import { MenuItem } from 'uiKit/atoms/MenuItem/MenuItem';
import { Select } from 'uiKit/atoms/Select/Select';
import { useStores } from 'stores';
import { DEFAULT_CURRENCY } from '../../../../constants';

import styles from './CurrencySelector.module.scss';

const CurrencySelector = ({ onFilterChange }) => {
  const { userStore, lotStore } = useStores();
  const { currency } = lotStore.filters;
  const { userProfile } = userStore;

  const currencyChangeHandler = event => {
    const newCurrency = event.target.value;
    onFilterChange([{ name: 'currency', value: newCurrency }]);
  };

  useEffect(() => {
    userStore.getCurrencies();
  }, [userStore]);

  return (
    <div className={styles.bns3_currency_select_wrapper}>
      <FormControl size="small" className={styles.bns3_currency_select}>
        <Select
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
          value={currency || userProfile.preferredCurrency || DEFAULT_CURRENCY}
          onChange={currencyChangeHandler}
          label="Currency"
          displayEmpty
          MenuProps={{
            PaperProps: {
              className: styles.bns3_currency_select_dropdown,
            },
          }}
        >
          {userStore.currencies.map(currencyItem => (
            <MenuItem
              key={`currenciesList${currencyItem}`}
              value={currencyItem}
              className={styles.bns3_dropdown_option}
            >
              {currencyItem}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default observer(CurrencySelector);
